import { UserEntityProfile, UserEntityProfileBase } from "./user-entity-profile.model";

export class UserEntityBase {

    id: number = 0
    entityId: number = 0
    userId: number = 0
    defaultEntity: boolean = false
    active: boolean = false
    profiles: UserEntityProfile[] = []

    static fromUserEntity(userEntity: UserEntity): UserEntityBase {
        let current = new UserEntityBase()
        if (userEntity == null) {
            return current
        }

        Object.assign(current, userEntity)
        
        current.profiles = []
        userEntity.profiles.forEach(p => {            
            let up = UserEntityProfileBase.fromUserEntityProfile(p)            
            current.profiles.push(up)
        })

        return current
    }

    hasProfile(profileId: number): boolean {
        return this.profiles.filter(p => p.profileId == profileId).length > 0
    }

}

export interface UserEntity extends UserEntityBase {
    
}